export function parseString(str, values = []) {
    let text = new String(str);
    values.forEach((value, index) => {
        let update = value;
        if (!update) {
            update = '';
        }
        else if (typeof value !== 'string' && typeof value !== 'number') {
            update = JSON.stringify(value);
        }
        text = text.replaceAll(`%${index + 1}$`, update);
    });
    return text;
}
